// --------------------------------------------------------------------------
// tab.js
// --------------------------------------------------------------------------
// Simple show/hide tab functionality
// --------------------------------------------------------------------------

RN.tabs = function() {

    'use strict';

    function init() {
        var tab = byBehaviour('tab');
        var firstTab = $(tab[0]);
        var firstPanel = $(firstTab.attr('href'));

        showTab(firstTab, firstPanel)

        tab.on('click', toggleTab);
    }

    function toggleTab() {
        var tab = $(this);
        var panel = tab.attr('href');
            panel = $(panel);

        if(!tab.hasClass('tab-nav__link--active')){
            var currentActiveTab = tab.closest('.tab-nav').find('.tab-nav__link--active');

            if(currentActiveTab.length){
                var currentActivePanel = $(currentActiveTab.attr('href'));

                currentActiveTab.removeClass('tab-nav__link--active');
                currentActivePanel.fadeOut(function(){
                    currentActivePanel.attr('aria-expanded','false');
                    showTab(tab, panel);
                });
            }
        }
        return false;
    }

    function showTab(tab, panel) {
        tab.addClass('tab-nav__link--active');
        panel.fadeIn(function(){ 
            panel.attr('aria-expanded','true');
            panel.focus();
        });
    }

    return {
        init: init
    };

}();